import React, { useState, useEffect, useRef } from 'react';
import PrimaryNavigation from '../../components/ui/PrimaryNavigation';
import NavigationBreadcrumb from '../../components/ui/NavigationBreadcrumb';
import FilterPanel from './components/FilterPanel';
import TimelineChart from './components/TimelineChart';
import ConversationTable from './components/ConversationTable';
import AnalyticsPanel from './components/AnalyticsPanel';
import ConversationDetailModal from './components/ConversationDetailModal';
import CallHistoryLogTable from './components/CallHistoryLogTable';
import CallDetailPane from './components/CallDetailPane';

const CallHistoryAnalytics = () => {
  const [filters, setFilters] = useState({});
  const [savedPresets, setSavedPresets] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [selectedCall, setSelectedCall] = useState(null);
  const [isCallDetailOpen, setIsCallDetailOpen] = useState(false);
  const tableRef = useRef(null);

  const timelineData = [
  { date: 'Dec 23', aiResolved: 145, escalated: 23, abandoned: 5 },
  { date: 'Dec 24', aiResolved: 132, escalated: 28, abandoned: 7 },
  { date: 'Dec 25', aiResolved: 98, escalated: 15, abandoned: 3 },
  { date: 'Dec 26', aiResolved: 167, escalated: 31, abandoned: 8 },
  { date: 'Dec 27', aiResolved: 189, escalated: 25, abandoned: 6 },
  { date: 'Dec 28', aiResolved: 201, escalated: 29, abandoned: 4 },
  { date: 'Dec 29', aiResolved: 215, escalated: 32, abandoned: 9 }];


  const conversationsData = [];


  const keywordData = [
  { name: 'Billing', value: 342 },
  { name: 'Technical', value: 287 },
  { name: 'Product', value: 234 },
  { name: 'Account', value: 198 },
  { name: 'Shipping', value: 156 },
  { name: 'Returns', value: 124 }];


  const responseTimeData = [
  { range: '0-2s', count: 847 },
  { range: '2-5s', count: 423 },
  { range: '5-10s', count: 156 },
  { range: '10-20s', count: 67 },
  { range: '20s+', count: 34 }];


  const escalationData = [
  { reason: 'Complex Technical Issue', count: 67, percentage: 36.6 },
  { reason: 'Policy Exception Request', count: 45, percentage: 24.6 },
  { reason: 'Billing Dispute', count: 34, percentage: 18.6 },
  { reason: 'Product Customization', count: 23, percentage: 12.6 },
  { reason: 'VIP Customer Request', count: 14, percentage: 7.6 }];


  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleSavePreset = (preset) => {
    setSavedPresets([...savedPresets, preset]);
  };

  const handleRowClick = (call) => {
    setSelectedCall(call);
    setIsCallDetailOpen(true);
  };

  const handleTagsChange = (conversationId, updatedTags) => {
    tableRef.current?.updateCallTags(conversationId, updatedTags);
    setSelectedCall(prev =>
      prev?.conversationId === conversationId ? { ...prev, tags: updatedTags } : prev
    );
  };

  const handleReviewChange = (callId, reviewStatus) => {
    tableRef.current?.updateCallReview(callId, reviewStatus);
    setSelectedCall(prev =>
      prev?.callId === callId ? { ...prev, reviewStatus } : prev
    );
  };

  const handleViewDetails = (conversation) => {
    setSelectedConversation(conversation);
  };

  const handleCloseModal = () => {
    setSelectedConversation(null);
  };

  return (
    <>
      <PrimaryNavigation />
      <div className="main-content">
        <div className="min-h-screen bg-background">
          <NavigationBreadcrumb />

          <main className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8">
            <div className="mb-6 md:mb-8">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">Call History Analytics</h1>
              <p className="text-sm md:text-base text-muted-foreground">
                Comprehensive analysis of customer interactions and conversation performance patterns
              </p>
            </div>

            {/* <FilterPanel
              onFilterChange={handleFilterChange}
              onSavePreset={handleSavePreset}
              savedPresets={savedPresets} /> */}

{/*
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
              <div className="lg:col-span-8 space-y-4 md:space-y-6">
                <TimelineChart data={timelineData} />
                <ConversationTable
                  conversations={conversationsData}
                  onViewDetails={handleViewDetails} />

              </div>

              <div className="lg:col-span-4">
                <AnalyticsPanel
                  keywordData={keywordData}
                  responseTimeData={responseTimeData}
                  escalationData={escalationData} />

              </div>
            </div> */}

            <CallHistoryLogTable ref={tableRef} onRowClick={handleRowClick} />

            <ConversationTable
              conversations={conversationsData}
              onViewDetails={handleViewDetails} />

          </main>

          {selectedConversation &&
          <ConversationDetailModal
            conversation={selectedConversation}
            onClose={() => setSelectedConversation(null)} />

          }

          <CallDetailPane
            isOpen={isCallDetailOpen}
            onClose={() => setIsCallDetailOpen(false)}
            callData={selectedCall}
            onTagsChange={handleTagsChange}
            onReviewChange={handleReviewChange} />

        </div>
      </div>
    </>);

};

export default CallHistoryAnalytics;